/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const echo = /* GraphQL */ `
  query Echo(
    $msg: String
    $org_id: Int
    $event_id: Int
    $run_id: Int
    $dryrun: Boolean
  ) {
    echo(
      msg: $msg
      org_id: $org_id
      event_id: $event_id
      run_id: $run_id
      dryrun: $dryrun
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const getRunDetail = /* GraphQL */ `
  query GetRunDetail($id: ID!) {
    getRunDetail(id: $id) {
      id
      run_id
      event_id
      group_id
      runJson
      runNotes
      runTimings
      racerFacts
      isProdReady
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listRunDetails = /* GraphQL */ `
  query ListRunDetails(
    $filter: ModelRunDetailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRunDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        run_id
        event_id
        group_id
        runJson
        runNotes
        runTimings
        racerFacts
        isProdReady
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncRunDetails = /* GraphQL */ `
  query SyncRunDetails(
    $filter: ModelRunDetailFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncRunDetails(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        run_id
        event_id
        group_id
        runJson
        runNotes
        runTimings
        racerFacts
        isProdReady
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const runDetailsByIsProdReady = /* GraphQL */ `
  query RunDetailsByIsProdReady(
    $isProdReady: String!
    $sortDirection: ModelSortDirection
    $filter: ModelRunDetailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    runDetailsByIsProdReady(
      isProdReady: $isProdReady
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        run_id
        event_id
        group_id
        runJson
        runNotes
        runTimings
        racerFacts
        isProdReady
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getEventList = /* GraphQL */ `
  query GetEventList($id: ID!) {
    getEventList(id: $id) {
      id
      eventId
      eventVenue
      eventName
      runList
      eventStartDate
      eventEndDate
      eventJson
      eventSource
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listEventLists = /* GraphQL */ `
  query ListEventLists(
    $filter: ModelEventListFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventId
        eventVenue
        eventName
        runList
        eventStartDate
        eventEndDate
        eventJson
        eventSource
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncEventLists = /* GraphQL */ `
  query SyncEventLists(
    $filter: ModelEventListFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncEventLists(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        eventId
        eventVenue
        eventName
        runList
        eventStartDate
        eventEndDate
        eventJson
        eventSource
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getSessionList = /* GraphQL */ `
  query GetSessionList($id: ID!) {
    getSessionList(id: $id) {
      id
      eventId
      sessionStart
      sessionEnd
      trackConfig
      sessionName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listSessionLists = /* GraphQL */ `
  query ListSessionLists(
    $filter: ModelSessionListFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessionLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventId
        sessionStart
        sessionEnd
        trackConfig
        sessionName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncSessionLists = /* GraphQL */ `
  query SyncSessionLists(
    $filter: ModelSessionListFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSessionLists(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        eventId
        sessionStart
        sessionEnd
        trackConfig
        sessionName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getVideoData = /* GraphQL */ `
  query GetVideoData($id: ID!) {
    getVideoData(id: $id) {
      id
      username
      drivername
      carNum
      cameraAngle
      sccaid
      nasaid
      greenFlag
      crossStart
      eventId
      runId
      sessionId
      vidSource
      srcVideoFormattedName
      tempLocalVideoLink
      tempLocalVideoUploadStatus
      vidUploadInitiated
      tempLocalTelemetryLink
      tempLocalTelemetryUploadStatus
      tracksideVideoUrl
      tracksideVideoUploadStatus
      tracksideTelemetryUrl
      tracksideTelemetryUploadStatus
      streamUrl
      youtubeStreamUrl
      telemetryS3Key
      laptimeData
      groups
      auditStatus
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listVideoData = /* GraphQL */ `
  query ListVideoData(
    $filter: ModelVideoDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoData(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        drivername
        carNum
        cameraAngle
        sccaid
        nasaid
        greenFlag
        crossStart
        eventId
        runId
        sessionId
        vidSource
        srcVideoFormattedName
        tempLocalVideoLink
        tempLocalVideoUploadStatus
        vidUploadInitiated
        tempLocalTelemetryLink
        tempLocalTelemetryUploadStatus
        tracksideVideoUrl
        tracksideVideoUploadStatus
        tracksideTelemetryUrl
        tracksideTelemetryUploadStatus
        streamUrl
        youtubeStreamUrl
        telemetryS3Key
        laptimeData
        groups
        auditStatus
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncVideoData = /* GraphQL */ `
  query SyncVideoData(
    $filter: ModelVideoDataFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncVideoData(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        username
        drivername
        carNum
        cameraAngle
        sccaid
        nasaid
        greenFlag
        crossStart
        eventId
        runId
        sessionId
        vidSource
        srcVideoFormattedName
        tempLocalVideoLink
        tempLocalVideoUploadStatus
        vidUploadInitiated
        tempLocalTelemetryLink
        tempLocalTelemetryUploadStatus
        tracksideVideoUrl
        tracksideVideoUploadStatus
        tracksideTelemetryUrl
        tracksideTelemetryUploadStatus
        streamUrl
        youtubeStreamUrl
        telemetryS3Key
        laptimeData
        groups
        auditStatus
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      name
      username
      sccaid
      nasaid
      htrDevice
      raceHeroName
      profileImage
      sponsor
      owner
      groups
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        username
        sccaid
        nasaid
        htrDevice
        raceHeroName
        profileImage
        sponsor
        owner
        groups
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncUserProfiles = /* GraphQL */ `
  query SyncUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserProfiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        name
        username
        sccaid
        nasaid
        htrDevice
        raceHeroName
        profileImage
        sponsor
        owner
        groups
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
